/**
 * 통합검색이 우리 `/api/search-all/similar-posts` 에 묻는 것 — 이미지가 비슷한 소셜 게시물.
 *
 * ⚠️ 관문 뒤라 로그인 토큰이 필수다(헤더를 빼면 401).
 */

import type { SimilarPostItem } from 'src/types/search-all/similar-post';

import { bearerAuthHeader } from 'src/lib/firebase/auth-kit';

import { resolveMockSimilarPosts } from './search-all-mock';

/**
 * @param query 게시물 `postId` 또는 이미지 `imageUrl` 중 하나 · `limit`
 * @returns 비슷한 순 — 실패면 빈 목록(화면은 「없음」으로 남는다)
 */
export async function fetchSimilarPosts(
  query: { postId?: string; imageUrl?: string; limit: number },
  signal?: AbortSignal,
): Promise<SimilarPostItem[]> {
  const mocked = resolveMockSimilarPosts(query);
  if (mocked) return mocked;

  const params = new URLSearchParams({ limit: String(query.limit) });
  if (query.postId) params.set('postId', query.postId);
  else if (query.imageUrl) params.set('imageUrl', query.imageUrl);
  else return [];
  const res = await fetch(`${SIMILAR_POSTS_PATH}?${params.toString()}`, { signal, headers: { ...(await bearerAuthHeader()) } });
  if (!res.ok) return [];
  const data = await res.json().catch(() => ({}));
  return Array.isArray(data?.similar) ? (data.similar as SimilarPostItem[]) : [];
}

/** ⚠️ 주소는 여기 한 곳뿐이다 */
const SIMILAR_POSTS_PATH = '/api/search-all/similar-posts';
